import angular from 'angular';

class ModalUnUpdatePdpSubEntityCtrl {

    close() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalUnUpdatePdpSubEntity', {
    templateUrl: require('./modal-unupdated-pdp-subEntity.html'),
    controller: ModalUnUpdatePdpSubEntityCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
